import script from "./Activity_GoodkidPreview2026.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_GoodkidPreview2026.vue?vue&type=script&setup=true&lang=js"

import "./Activity_GoodkidPreview2026.vue?vue&type=style&index=0&id=16d68040&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16d68040"]])

export default __exports__